import { ActivityV2 } from 'models/activityV2'
import { Editor } from 'components/Editor/Editor'
import { JsonIntoUl } from 'components/json-into-ul'
import { BaseEventCard, getActionText } from './BaseEventCard'

interface NoteEventCardProps {
  event: ActivityV2
}

export function NoteEventCard({ event }: NoteEventCardProps) {
  // Get note content from field_history_objects
  const contentField = event.field_history_objects?.find(
    (field) => field.field_name === 'content'
  )
  const noteContent = contentField?.value || ''

  return (
    <BaseEventCard event={event}>
      <div className="space-y-1">
        {/* User name and action */}
        <div className="font-inter text-sm leading-[1.43] text-gray-500">
          <span className="text-gray-700 font-bold">{event.user_name}</span>{' '}
          {getActionText(event.action_type, 'note')}
        </div>

        {/* Note content */}
        {noteContent && (
          <div className="text-sm text-gray-700">
            <JsonIntoUl
              value={noteContent}
              fallback={
                <Editor
                  value={noteContent}
                  readOnly={true}
                  disableToolbar={true}
                  borderless={true}
                />
              }
            />
          </div>
        )}
      </div>
    </BaseEventCard>
  )
}
